import SectionHeading from '@/components/feature/SectionHeading';
import { methodSteps } from '@/mocks/site';

export default function MethodSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]">
          <div>
            <SectionHeading
              eyebrow="Method"
              title="我们是怎么「看料」的"
              desc="深扒不是把人扒光，而是把信息整理清楚。每篇文章背后，都经过同一套固定的核查流程。"
            />
            <div className="mt-8 rounded-lg bg-accent-900 p-6 md:p-7">
              <i className="ri-double-quotes-l text-2xl text-accent-300" />
              <p className="mt-3 text-sm leading-relaxed text-background-100">
                孤证不立，是我们最朴素也最坚持的一条规矩。如果一个结论找不到第二条独立来源，我们宁可把它写成「待观察」。
              </p>
              <p className="mt-4 text-xs text-accent-200">—— 爆料看料编辑部</p>
            </div>
          </div>

          <ol className="relative space-y-4">
            {methodSteps.map((step) => (
              <li
                key={step.index}
                className="flex gap-5 rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
              >
                <span className="font-heading flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-md bg-primary-500 text-base font-bold text-background-50">
                  {step.index}
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}